<template>
  <div class="carmodel">
    <div :class="item.id==select_id?'area_box area_select':'area_box'" v-for="item in list" :key="'list_' + item.id" @click="selectModels(item.id,item.title)">
      <div class="area_titie">{{item.title}}</div>
      <img class="arrow" :src="img.arrow">
    </div>
    <div class="addmodels text-c" @click="showDialog">没有我的车型，<span style="color:#605C6B">填写我的车型</span></div>
    <van-popup v-model="show">
      <div class="block">
        <div class="text-c f-16 mb-20">我的车型</div>
        <van-field v-model="model" placeholder="车型" />
        <van-button type="default" size="large" color="#605C6B" style="margin-top: 30px;" @click="submit">确认提交</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import list from '../../../api/member/mycars';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import {Cell, CellGroup,Popup,Field,Toast,Button,Dialog } from 'vant';
  export default {
    data () {
      return {
        show: false,
        select_id:0,
        list:[],
        ever:0,
        model:'',
        img:{
          china: require('../../../assets/img/lexus/china.png'),
          foregin: require('../../../assets/img/lexus/foregin.png'),
          arrow: require('../../../assets/img/lexus/arrow.png'),
          travel: require('../../../assets/img/travel.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.region=this.$route.query.type
      this.ever=this.$route.query.ever
      this.id=this.$route.query.id
      this.gid=this.$route.query.gid
      this.name=this.$route.query.carname
      this.is_have_card=this.$route.query.is_have_card
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      this.weburl=process.env.VUE_APP_URL
      this.getModels()
      var params={
        event_code: '车主认证_选择车型',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/CarModel.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      getModels(){
        var params={
          car_generation_id:this.gid,
          car_id:this.id,
        }
        list.getModels(params).then(res => {
          var list=res.data.data
          if(res.data.state == 1) {
            this.list=res.data.data
            this.select_id=list[0].id
          }
        })
      },
      showDialog(){
        this.show=true
      },
      hideDialog(){
        this.show=false
      },
      submit(){
        if(this.model==''){
          Toast('请填写车型');
        }else{
          var params={
            url:this.weburl+'/lexus/my/car_info?type='+this.region+ '&carname='+encodeURI('雷克萨斯 '+this.model)+'&source='+this.source+'&ever='+this.ever+'&id=' + this.id + '&gid=' + this.gid + '&car_model_name=' + encodeURI(this.model)+'&is_have_card='+this.is_have_card,
            isReturn: true 
          }
          this.$appService.openWebView(params)
          this.show=false
        }
        
      },
      selectModels(id,name){
        this.select_id=id
        var params={
          url:this.weburl+'/lexus/my/car_info?type='+this.region+'&id='+this.id+ '&carname='+encodeURI(this.name+name)+'&gid='+this.id+'&model_id=' + id+'&source='+this.source+'&ever='+this.ever+'&is_have_card='+this.is_have_card,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      },
    },
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Popup.name]:Popup,
      [Field.name]:Field,
      [Toast.name]:Toast,
      [Button.name]:Button,
      [Dialog.name]:Dialog
    }
  }
</script>
<style lang="scss">
.carmodel{
  .area_box{
    display: flex;
    align-items: center;
    padding: 20px 15px;
    border-bottom: 0.5px solid rgba(0,0,0,.1);
    .area_pic{
      width: 150px;
      height: 80px;
      margin-left: 20px;
    }
    .area_titie{
      flex: 1;
      font-size:14px;
      text-align: center;
    }
    .arrow{
      width: 10px;
      height: 12px;
      float: right;
    }
  }
  .area_select{
    background-color: #EAEAEA;
  }

  .knowBtn{
    width: 100%;
    height: 45px;
    color: #fff;
    background: #605C6B;
    font-size: 14px;
    font-weight: 400;
    margin-top: 10px;
  }
  .addmodels{
    padding: 25px;
    font-size: 14px;
  }
  .van-popup{
    width: 80%;
    min-height: 100px;
    padding: 15px;
    .mb-20{
      margin-bottom: 20px
    }
    .van-field{
      background-color: #EEEEEE;
      border-radius: 1px;
      margin-top: 15px;
    }
  }
}
</style>
